import React from 'react';

const ServicesPage = () => (
  <main className="services">
    <div className="container">
      <section className="sv-hero">
        <div className="sv-eyebrow">Services</div>
        <h1 className="sv-title">Maximizing IT Value with Secure and Sustainable Solutions</h1>
        <p className="sv-subtitle">From certified data destruction to remarketing and recycling, we help organizations recover value, stay compliant, and operate sustainably across the entire technology lifecycle.</p>
      </section>

      <section className="sv-solutions">
        <h2 className="sv-section-title">Core Service Areas</h2>
        <div className="sv-card-grid">
          <article className="sv-card">
            <div className="sv-card-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M7 8h10M7 12h10"/></svg>
            </div>
            <div className="sv-card-body">
              <h3>IT Asset Disposition (ITAD)</h3>
              <p>Certified data erasure, hardware sanitization, and compliant chain-of-custody.</p>
              <ul className="sv-list">
                <li>Secure Data Destruction (NIST 800-88, HIPAA, GDPR)</li>
                <li>Asset Recovery & Remarketing</li>
                <li>Certified Document Destruction</li>
                <li>Compliance reporting and certificates</li>
              </ul>
            </div>
          </article>

          <article className="sv-card">
            <div className="sv-card-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2a10 10 0 1 0 10 10"/><path d="M20 2v6h-6"/></svg>
            </div>
            <div className="sv-card-body">
              <h3>Asset Refresh & Redeployment</h3>
              <p>Extend device life with structured evaluation, wipe, and redeploy programs.</p>
              <ul className="sv-list">
                <li>Device evaluation and grading</li>
                <li>Data migration and imaging</li>
                <li>Asset tracking and logistics</li>
                <li>Lifecycle cost optimization</li>
              </ul>
            </div>
          </article>

          <article className="sv-card">
            <div className="sv-card-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="9"/><path d="M8 12h8M12 8v8"/></svg>
            </div>
            <div className="sv-card-body">
              <h3>Electronics Recycling</h3>
              <p>Responsible processing aligned to R2 / e‑Stewards standards and reporting.</p>
              <ul className="sv-list">
                <li>Certified downstream vendors</li>
                <li>Environmental impact reports</li>
                <li>Brand protection controls</li>
                <li>Circular economy enablement</li>
              </ul>
            </div>
          </article>
        </div>
      </section>

      <section className="sv-overview">
        <div className="sv-overview-grid">
          <div>
            <h2 className="sv-section-title">Milestones</h2>
            <h3 className="sv-section-title" style={{fontSize: '18px', fontWeight: 600, marginTop: '6px'}}>Driving E‑Waste Reduction and Global Sustainability</h3>
            <p>Annually cut clients’ electronic waste by more than half through innovative recycling programs, supported 352 clients in meeting sustainability and environmental compliance standards, and collaborated with 147 global organizations to further the e‑waste recycling movement and promote responsible disposal.</p>
          </div>
          <aside className="sv-stats">
            <div className="sv-stat"><div className="sv-stat-num">50%+</div><div className="sv-stat-label">e‑waste reduction</div></div>
            <div className="sv-stat"><div className="sv-stat-num">352</div><div className="sv-stat-label">clients supported</div></div>
            <div className="sv-stat"><div className="sv-stat-num">147</div><div className="sv-stat-label">global partners</div></div>
          </aside>
        </div>
      </section>

      <section className="sv-features">
        <h2 className="sv-section-title">Platform Capabilities</h2>
        <div className="sv-features-grid">
          <div className="sv-feature">
            <h4>Secure Data Destruction & Compliance</h4>
            <p>NIST 800‑88 aligned erasure with per‑asset certificates, chain‑of‑custody logs, and audit‑ready reports.</p>
          </div>
          <div className="sv-feature">
            <h4>Asset Recovery & Remarketing</h4>
            <p>Global buyer network, graded listings, and price guidance to maximize recovery across channels.</p>
          </div>
          <div className="sv-feature">
            <h4>Redeployment & Imaging</h4>
            <p>Device evaluation, OS imaging, and configuration for quick redeploy to teams or secondary sites.</p>
          </div>
          <div className="sv-feature">
            <h4>Certified Electronics Recycling</h4>
            <p>R2/e‑Stewards aligned processing, environmental impact summaries, and responsible material flow.</p>
          </div>
        </div>
      </section>

      <section className="sv-cta">
        <div className="sv-cta-inner">
          <h3>Ready to modernize your IT disposition program?</h3>
          <p>Connect with our team to design a solution tailored to your operation.</p>
          <div className="sv-cta-actions">
            <a className="btn btn-primary" href="tel:+18778739336">Call (877) 873-9336</a>
            <a className="btn btn-secondary" href="mailto:info@globoflo.com">Email Us</a>
          </div>
        </div>
      </section>
    </div>
  </main>
);

export default ServicesPage;
